const _ = "_image_19sk4_17", o = "_content_19sk4_34", t = "_icon_19sk4_58", e = "_details_19sk4_70", a = "_bio_19sk4_80", s = "_modal_19sk4_94", n = {
  "item-wrapper": "_item-wrapper_19sk4_1",
  image: _,
  content: o,
  icon: t,
  details: e,
  bio: a,
  modal: s,
  "modal-image": "_modal-image_19sk4_111",
  "modal-content": "_modal-content_19sk4_132",
  "modal-header": "_modal-header_19sk4_143"
};
export {
  a as bio,
  o as content,
  n as default,
  e as details,
  t as icon,
  _ as image,
  s as modal
};
